<app-nav class="w-100"></app-nav>
<section class="banner">

  <app-category-searchbar
    [searchText]="searchQuery"
    [ou]="searchOu"
    [colors]="colors"
  >
  </app-category-searchbar>

  <div #air id="air" class="air kenburns-top"></div>
</section>
<app-no-data *ngIf="data.length == 0 && !skelition"></app-no-data>

<app-skelitions [hidden]="!skelition" [value]="7"></app-skelitions>
<div class="container-fluid v4-bg-img" *ngIf="data.length > 0 && !skelition">
  <div class="row">
    <div class="col-12 d-flex justify-content-start wrapp p-right">
      <div
        class="custom-cat-btn" 
        style="cursor: pointer"
        *ngFor="let n of data_types"
        (click)="applyTypeFilter(n?.name)"
        [ngClass]="currentTypeFilter == n?.name ? 'active' : ''"
      >
        <span class="custom-cat-btn-num">{{
          counter(n?.name).toString()
        }}</span>
        <span><i class="pi-fw {{ n?.icon }} mx-2 icon-1-2rem"></i></span>
        <span>{{ n?.arabic }}</span>
      </div>
    </div>

    <!-- Subcategories strip: below type filter, above data table - show whenever we're in a category so back is always available -->
    <div class="row mt-2 subcategory-strip-row" *ngIf="searchOu">
      <div class="col-12">
        <div class="d-flex align-items-center subcategory-strip">
          <button
            *ngIf="searchOu"
            type="button"
            class="subcategory-back-btn"
            [pTooltip]="'Back' | translator"
            [tooltipPosition]="'top'"
            (click)="uniqueMinistries[0]?.parent ? AddOuAndSearch(uniqueMinistries[0].parent.id) : removeOuAndSearch()"
          >
            <i class="pi pi-arrow-right"></i>
            <span>{{ uniqueMinistries[0]?.parent ? uniqueMinistries[0].parent.name : ('Homepage' | translator) }}</span>
          </button>
          <div class="subcategory-strip-scroll d-flex align-items-center gap-2">
            <span class="subcategory-strip-label" *ngIf="visibleSubcategoryOus.length > 0">{{ 'Subcategories' | translator }}:</span>
            <ng-container *ngFor="let child of visibleSubcategoryOus">
              <button
                type="button"
                class="subcategory-chip"
                [class.subcategory-chip-active]="searchOu == child.id"
                (click)="AddOuAndSearch(child.id)"
              >
                <span class="subcategory-chip-count">{{ addAll(child.id) }}</span>
                <span class="subcategory-chip-name">{{ child.name }}</span>
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'Entites Filter' | translator }}"
      [(visible)]="displayDialog"
      (onHide)="onDialogClose()"
      [modal]="true"
      [style]="{ width: '95vw', maxWidth: '1300px' }"
    >
      <div *ngIf="ouLoading" class="d-flex w-100 justify-content-center p-5">
        <p-progressSpinner
          [style]="{ width: '100px', height: '100px' }"
        ></p-progressSpinner>
      </div>

      <div class="bg-rgb" *ngIf="!ouLoading">
        <div
          class="d-flex flex-wrap flex-row gap-2 align-items-center justify-content-start"
        >
          <span class="ouBread" (click)="removeOuAndSearch()">
            <i class="pi pi-home"></i>
            {{ "Homepage" | translator }}
          </span>

          <span
            *ngIf="
              searchOu &&
              uniqueMinistries[0] &&
              uniqueMinistries[0]?.grandparent
            "
          >
            <i class="pi pi-chevron-left"> </i>
          </span>

          <span
            class="ouBread"
            *ngIf="
              searchOu &&
              uniqueMinistries[0] &&
              uniqueMinistries[0]?.grandparent
            "
            (click)="AddOuAndSearch(uniqueMinistries[0]?.grandparent.id)"
          >
            <img
              *ngIf="
                checkisImg(uniqueMinistries[0]?.grandparent.image);
                else elseBlock
              "
              src="{{ siteUrl }}{{ uniqueMinistries[0]?.grandparent.image }}"
              class="img-fluid 111"
              style="
                height: 22px;
                max-width: 22px;
                margin-left: 5px;
                background: white;
                border-radius: 3px;
              "
              alt="{{ uniqueMinistries[0]?.grandparent.name }}"
            />
            <ng-template #elseBlock>
              <i
                style="margin-left: 10px"
                class="{{ uniqueMinistries[0]?.grandparent.image }}"
              ></i>
            </ng-template>

            {{ uniqueMinistries[0]?.grandparent.name }}
          </span>

          <span
            *ngIf="
              searchOu && uniqueMinistries[0] && uniqueMinistries[0]?.parent
            "
          >
            <i class="pi pi-chevron-left"> </i>
          </span>

          <span
            class="ouBread"
            *ngIf="
              searchOu && uniqueMinistries[0] && uniqueMinistries[0]?.parent
            "
            (click)="AddOuAndSearch(uniqueMinistries[0]?.parent.id)"
          >
            <img
              *ngIf="
                checkisImg(uniqueMinistries[0]?.parent.image);
                else elseBlock
              "
              src="{{ siteUrl }}{{ uniqueMinistries[0]?.parent.image }}"
              class="img-fluid 222"
              style="
                height: 22px;
                max-width: 22px;
                margin-left: 5px;
                background: white;
                border-radius: 3px;
              "
              alt="{{ uniqueMinistries[0]?.parent.name }}"
            />
            <ng-template #elseBlock>
              <i
                style="margin-left: 10px"
                class="{{ uniqueMinistries[0]?.parent.image }}"
              ></i>
            </ng-template>

            {{ uniqueMinistries[0]?.parent.name }}
          </span>

          <span *ngIf="searchOu && uniqueMinistries[0]">
            <i class="pi pi-chevron-left"> </i>
          </span>

          <span
            class="ouBread"
            *ngIf="searchOu && uniqueMinistries[0]"
            (click)="AddOuAndSearch(uniqueMinistries[0]?.id)"
          >
            <img
              *ngIf="checkisImg(uniqueMinistries[0]?.image); else elseBlock"
              src="{{ siteUrl }}{{ uniqueMinistries[0]?.image }}"
              class="img-fluid 333"
              style="
                height: 22px;
                max-width: 22px;
                margin-left: 5px;
                background: white;
                border-radius: 3px;
              "
              alt="{{ uniqueMinistries[0]?.name }}"
            />
            <ng-template #elseBlock>
              <i
                style="margin-left: 10px"
                class="{{ uniqueMinistries[0]?.image }}"
              ></i>
            </ng-template>

            {{ uniqueMinistries[0]?.name }}
          </span>
        </div>

        <ng-container *ngIf="!searchOu && displayDialog">
          <!-- the selected OU -->
          <!-- <div class="w-100 d-flex flex-row flex-wrap justify-content-center gap-2 mt-2"> -->
          <div class="row mt-2 justify-content-center">
            <div
              class="justify-content-center mt-3"
              [ngClass]="
                uniqueMinistries && uniqueMinistries.length > 4
                  ? 'col-md-3 col-12'
                  : 'col-md-4 col-12'
              "
              *ngFor="let object of uniqueMinistries"
            >
              <p-button
                size="small"
                [badge]="addAll(object?.id)"
                (click)="AddOuAndSearch(object?.id)"
                styleClass="text-wrap outlines w-100 h-100"
                class="w-100 h-100"
                [label]="object?.label"
              >
                <img
                  *ngIf="checkisImg(object?.icon); else elseBlock"
                  src="{{ siteUrl }}{{ object?.icon }}"
                  class="img-fluid"
                  style="height: 30px; max-width: 30px; margin-left: 5px"
                  alt="{{ object?.label }}"
                />
                <ng-template #elseBlock>
                  <i style="margin-left: 10px" class="{{ object?.icon }}"></i>
                </ng-template>
              </p-button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="searchOu && displayDialog">
          <ng-container *ngFor="let object of uniqueMinistries">
            <!-- For Parent -->
            <!-- <div class="row mt-2 justify-content-center">

                    <div class="col-4 justify-content-center  mt-3" *ngIf="object?.parent">
                        <p-button size="small" [badge]="addAll(object?.parent.id)" (click)="AddOuAndSearch(object?.parent.id)"
                        [label]="object?.parent.name" styleClass="text-wrap outlines w-100 h-100" class="w-100 h-100" >
                        <img *ngIf="checkisImg(object?.parent.image); else elseBlock" src="{{siteUrl}}{{object?.parent.image}}"
                            class="img-fluid" style="height: 30px; max-width: 30px; margin-left: 10px;" alt="{{object?.parent.name}}">
                        <ng-template #elseBlock>
                            <i style="margin-left: 10px;" class="{{object?.parent.image}}"></i>
                        </ng-template>
                        </p-button>
                    </div>

                </div> -->

            <!-- the selected OU -->
            <!-- <div class="row mt-2 justify-content-center">

              <div class="col-4 justify-content-center  mt-3">
                <p-button size="small" [badge]="addAll(object?.id)" styleClass="text-wrap inlines w-100 h-100"
                  class="w-100 h-100" [label]="object?.name">
                  <img *ngIf="checkisImg(object?.image); else elseBlock" src="{{siteUrl}}{{object?.image}}"
                    class="img-fluid" style="height: 30px; max-width: 30px; margin-left: 10px;" alt="{{object?.name}}">
                  <ng-template #elseBlock>
                    <i style="margin-left: 10px;" class="{{object?.image}}"></i>
                  </ng-template>
                </p-button>
              </div>

            </div> -->

            <!-- children ous -->
            <!-- <div class="w-100 d-flex flex-row flex-wrap justify-content-center gap-2 mt-2" -->
            <div
              class="row mt-2 justify-content-center"
              *ngIf="object && object.children && object.children.length > 0"
            >
              <ng-container *ngFor="let child of object.children">
                <div
                  class="justify-content-center mt-3"
                  [ngClass]="object.children.length > 4 ? 'col-md-3 col-12' : 'col-md-4 col-12'"
                  *ngIf="addAllnum(child.id) > 0"
                >
                  <p-button
                    size="small"
                    styleClass="text-wrap outlines w-100 h-100"
                    class="w-100 h-100"
                    (click)="AddOuAndSearch(child.id)"
                    [badge]="addAll(child.id)"
                    [label]="child?.name"
                  >
                    <img
                      *ngIf="checkisImg(child?.image); else elseBlock"
                      src="{{ siteUrl }}{{ child?.image }}"
                      class="img-fluid"
                      style="height: 30px; max-width: 30px; margin-left: 10px"
                      alt="{{ child?.name }}"
                    />
                    <ng-template #elseBlock>
                      <i
                        style="margin-left: 10px"
                        class="{{ child?.image }}"
                      ></i>
                    </ng-template>
                  </p-button>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <ng-template pTemplate="footer">
        <div class="w-100 d-flex align-items-center justify-content-center">
          <button class="v4-btn-every" (click)="onOuSelected()">{{
            "Submit filter" | translator
          }}</button>
        </div>
      </ng-template>
    </p-dialog>
  </div>

  <div class="container-fluid max-width p-0 py-4 2222">
    <div class="row ms-bg-row">
      <div class="container">
        <div
          [pTooltip]="'ou filter' | translator"
          [tooltipPosition]="'top'"
          class="position-absolute margin-mob-web"
          style="margin-top: -5.5rem"
        >
          <p-button
            (click)="openDialog()"
            [styleClass]="'filter-btn-ui ext-light p-button-lg btn-wd'"
          >
            <i
              *ngIf="searchOu"
              class="pi pi-filter bg-color-v4"
              style="font-size: 1.5rem"
              pBadge
              severity="warning"
              [value]="'!'"
            ></i>
            <i
              *ngIf="!searchOu"
              class="pi pi-filter"
              style="font-size: 1.5rem"
            ></i>
          </p-button>
        </div>
      </div>

      <div class="col-md-4 col-12 my-2 poss-rel d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center user-category">
          <span class="custom-pagination-text">
            <span class="d-flex">
              <span>&nbsp;{{ "results" | translator }}&nbsp;</span>
              <span>{{ currentPage * 10 - 9 }} - {{ currentPage * 10 > totalRecords ? totalRecords : currentPage * 10 }}</span>
              <span>{{ "from" | translator }} {{ totalRecords }}</span>
            </span>
            </span
          >
          <div class="d-flex">
            <span class="custom-pagination" (click)="moveToLast(true)"
              ><i class="pi pi-fw pi-angle-double-right icon-x2"></i
            ></span>
            <span
              class="custom-pagination"
              (click)="changePage(currentPage - 1)"
              ><i class="pi pi-fw pi-angle-right icon-x2"></i
            ></span>
            <span class="custom-pagination" style="font-size: x-small">{{
              currentPage
            }}</span>
            <span
              class="custom-pagination"
              (click)="changePage(currentPage + 1)"
              ><i class="pi pi-fw pi-angle-left icon-x2"></i
            ></span>
            <span class="custom-pagination" (click)="moveToLast(false)"
              ><i class="pi pi-fw pi-angle-double-left icon-x2"></i
            ></span>
          </div>
        </div>
        <span class="circle-numer">
          <span
            *ngFor="let i of pages"
            class="circle-num-ui"
            [ngClass]="currentPage == changeToNumber(i) ? 'active' : ''"
            (click)="currentPage = changeToNumber(i); changePage(currentPage)"
            >{{ i }}</span
          >
        </span>

        <div class="card border-none card-mobile-alignment ms-bg custom-vw-30">
         

          <!-- <p-button [label]="(index+1) + ((currentPage-1)*10)"
              styleClass="p-button-outline p-button-sm p-button-text indexnum m-2">
              </p-button> -->

          <p-dataView class="p-data-dark-ui"
            #dv
            *ngIf="data.length > 0"
            [value]="data"
            [rows]="10"
            [paginator]="true"
            filterBy="name,fields.data,id,ministry.id,ministry.name,uniqueid,type.name,type.arabic,active"
            [sortField]="sortField"
            [sortOrder]="sortOrder"
            (onPage)="onPageChange($event)"
            paginatorPosition="none"
            emptyMessage="{{ 'There is no data' | translator }}"
          >
            <ng-template let-item let-index="rowIndex" pTemplate="listItem">
              <div style="margin: 1rem" class="all-hover">
                <div class="d-flex justify-content-center align-items-center">
                  <div
                    class="d-flex justify-content-center align-items-center ms-box-ui"
                    [ngClass]="
                      currentService?._id == item._id
                        ? 'D-active'
                        : 'active-white'
                    "
                    (click)="changeView(item)"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <button
                        class="purple-index"
                        [ngClass]="
                          currentService?._id == item._id
                            ? 'active-purple-index'
                            : 'purple-index'
                        "
                        (click)="changeView(item)"
                      >
                        {{ index + 1 + (currentPage - 1) * 10 }}
                      </button>
                    </div>
                    <div
                      class="d-flex flex-row flex-nowrap flex-wrap align-items-center ms-box-view"
                    >
                      <div>
                        <div class="mb-0"></div>
                        <div
                          class="d-coll"
                          [ngClass]="
                            currentService?._id == item._id
                              ? ''
                              : 'active-whitee'
                          "
                          (click)="changeView(item)"
                        >
                          <div
                            class="d-flex justify-content-start align-items-center w-100"
                          >
                            <img
                              *ngIf="
                                item &&
                                  item.ministry &&
                                  item.ministry.icon &&
                                  checkisImg(item.ministry.icon);
                                else elseBlock
                              "
                              src="{{ staticURL }}{{ item.ministry.icon }}"
                              class="img-fluid p-1"
                              style="max-height: 30px; max-width: 30px"
                            />
                            <ng-template #elseBlock>
                              <i
                                class="{{ item.ministry.icon }} p-2"
                                style="font-size: 1rem"
                              ></i>
                            </ng-template>
                            <div class="us-m-lh">
                              <b
                                class="pic-text"
                                [ngClass]="
                                  currentService?._id == item._id
                                    ? 'D-active-p'
                                    : 'pic-text'
                                "
                                (click)="changeView(item)"
                              >
                                {{ item.ministry.label }} - {{ item.id }}
                                {{ item.ministry.id }}</b
                              >
                            </div>
                          </div>
                        </div>
                        <p class="nano-text">
                          <b
                            class="ms-bold-text"
                            [innerHTML]="item.name | highlight : searchQuery"
                            [ngClass]="
                              currentService?._id == item._id
                                ? 'D-active-p'
                                : 'ms-bold-text'
                            "
                            (click)="changeView(item)"
                          ></b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- ============================================================================================================== -->
            </ng-template>
          </p-dataView>
          <div class="d-flex justify-content-between align-items-center user-category mx-3">
            <span class="custom-pagination-text">
              <span class="d-flex">
              <span>&nbsp;{{ "results" | translator }}&nbsp;</span>
              <span>{{ currentPage * 10 - 9 }} -
                {{ first + rows > totalRecords ? totalRecords : first + rows }}</span>
              <span>{{ "from" | translator }} {{ totalRecords }}</span>
              </span>
            </span>
            <div class="d-flex">
              <span class="custom-pagination" (click)="moveToLast(true)"
                ><i class="pi pi-fw pi-angle-double-right icon-x2"></i
              ></span>
              <span
                class="custom-pagination"
                (click)="changePage(currentPage - 1)"
                ><i class="pi pi-fw pi-angle-right icon-x2"></i
              ></span>
              <span
                class="custom-pagination"
                (click)="changePage(currentPage + 1)"
                ><i class="pi pi-fw pi-angle-left icon-x2"></i
              ></span>
              <span class="custom-pagination" (click)="moveToLast(false)"
                ><i class="pi pi-fw pi-angle-double-left icon-x2"></i
              ></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-md-8 col-12 margin-mob"
        *ngIf="
          !fetchingCurrent && currentItem && currentItem?.fields?.length > 0
        "
      >
        <div class="ms-bg-left-custom">
          <div
            class="row d-flex justify-content-between flex-start mob-flex-column mb-4"
          >
            <!-- <h2 [innerHTML]="currentItem.name | highlight: searchQuery" class="card-title manage-margin"
                      style="font-weight: 600; color: var(--color-1)"></h2> -->

            <!-- <div class="d-flex flex-row align-items-center wrapp">

            <span class="d-flex align-items-center my-1"
                [routerLink]="item.routerLink">
                <span class="custom-bredcrum-btn d-flex align-items-center">
                    <i [hidden]="item.image" class="{{item.icon}} me-1"></i>
                    <img [hidden]="!item.image" [src]="staticURL+item.image"
                        style="max-height: 1.2rem; max-width: 1.2rem;" class="blacknWhite img-fluid me-1">
                    {{item.label}}
                </span>
                <span class=""><i class="pi pi-fw pi-angle-left"></i></span>

            </span>

          </div> -->

            <div
              class="col-md-6 col-12 d-flex flex-row align-items-center wrapp"
            >
              <div
                *ngFor="let item of currentItem.breadcrumbs; let i = index"
                class="mt-2 mx-2 d-flex flex-row align-items-center"
              >
                <div class="d-flex" *ngIf="i != 0"><i class="fa-solid fa-angle-left color-grey"></i></div>

                <div
                  [routerLink]="['/search-view']"
                  class="d-flex flex-row flex-nowrap cursor"
                  [queryParams]="{
                    ou: item.id,
                    searchTerm: 'all',
                    data: currentItem?.id
                  }"
                >
                  <img
                    *ngIf="checkisImg(item.icon); else elseBlock"
                    src="{{ staticURL }}{{ item.icon }}"
                    class="img-fluid p-1 cat-img"/>
                  <ng-template #elseBlock>
                    <i
                      class="{{ item.icon }} p-2 cat-icone"
                    ></i>
                  </ng-template>
                  <span
                    class="text-wrap cat-text"
                    >{{ item.label }}</span>
                </div>
              </div>
            </div>

            <div
              class="col-md-6 col-12 d-flex flex-row flex-nowrap gap-1 justify-content-end"
            >
            <div class="cust-d-ruby">
              <div *ngIf="hasPermission('u')" class="cust-flex">
                <span class="btn-flex-circle mx-1">
                  <span class="d-flex flex-column">
                    <span class="mx-2">{{
                      "Last updated" | translator
                    }}</span>
                    <span class="mx-2 font-0_8rem font-weight-200">{{
                      currentItem.updatedAt | date : "MMMM d, y | h:mm:ss a"
                    }}</span>
                  </span>
                  <span class="icon-box">
                    <i class="pi pi-calendar font-500"></i>
                  </span>
                </span>
              </div>

              <div class="cust-flex">
                <!-- <span class="btn-flex mx-1">
                <span class="d-flex flex-column">
                  <span class="btn-css mx-2">{{'Related Services' | translator}}</span>
                </span>
                <span [routerLink]="'/search-view'" [queryParams]="{ ou: getLastBreadcrumbId(currentItem),  searchTerm: 'all', data: currentItem?.id} " class="icon-box cccc" style="cursor: pointer;" 
                [pTooltip]="'Related Services' | translator">
                  <i class="pi pi-list font-500"></i>
                </span>
              </span> -->

                <button
                  class="comment-btn border-15"
                  [routerLink]="'/search-view'"
                  [queryParams]="{
                    ou: getLastBreadcrumbId(currentItem),
                    searchTerm: 'all',
                    data: currentItem?.id
                  }"
                >
                  <i class="pi pi-list mx-2"></i
                  >{{ "Related Services" | translator }}
                </button>
              </div>
            </div>

            </div>

            <!-- New Changes -->
            <div class="col-md-12 col-12 d-flex my-3">
              <div *ngIf="hasPermission('u') && editPermission && this.hasEditPermissionWithType()" class="d-flex">
                <i
                  [hidden]="editFlag == true"
                  (click)="openEdit()"
                  class="pi pi-fw pi-pencil edit-btn"
                ></i>
                <i
                  [hidden]="editFlag == false"
                  (click)="cancelEdit()"
                  class="pi pi-times-circle edit-btn"
                ></i>
              </div>
              <div class="column pos-rel w-100">
                <h2
                  [hidden]="editFlag"
                  class="color-grey"
                  [innerHTML]="currentItem.name | highlight : searchQuery"
                ></h2>
                <label
                  [hidden]="editFlag == false"
                  class="name-position"
                  >{{ "The address" | translator }}</label
                >
                <input
                  [hidden]="!editFlag"
                  pInputText
                  [(ngModel)]="currentItem.name"
                  class="w-100 edit-input-ui"
                  [id]="currentItem.name"
                  type="text"
                />
              </div>
            </div>
          </div>

          <p-messages [(value)]="messages" [enableService]="false"></p-messages>

          <p-accordion
            class="w-full"
            [multiple]="true"
            [activeIndex]="fieldAccordionActiveIndices"
            *ngIf="currentItem && currentItem.fields.length > 0"
          >
            <span *ngFor="let field of currentItem?.fields; let i = index">
              <p-accordionTab
                class="my-3"
                iconPos="end"
                [selected]="i==0 || i ==1"
              >
                <ng-template pTemplate="header">
                  <div class="d-flex align-items-center">
                    <p-checkbox
                      (click)="$event.stopPropagation()"
                      [hidden]="!editFlag"
                      [(ngModel)]="field.isChecked"
                      class="shadow"
                      [binary]="true"
                      inputId="binary"
                    ></p-checkbox>
                    <i
                      [ngClass]="field.label?.icon + ' font-1_2rem'"
                      class="m-2"
                    ></i>
                    <span class="vertical-align-middle font-1_1rem">{{
                      field.label?.name
                    }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <div *ngIf="!editFlag" class="row">
                    <!-- For View -->
                    <div class="col-12">
                      <div
                        *ngIf="fieldTypes"
                        [ngSwitch]="getFieldType(field.label?.type)"
                      >
                        <!-- For text -->
                        <div *ngSwitchCase="'text'">
                          <div
                            class="line-space mb-0 datacontent"
                            *ngIf="field.data"
                            [innerHTML]="
                              field.data | highlight : searchQuery | safeHTML
                            "
                          ></div>
                        </div>
                        <!-- Rich text -->
                        <div *ngSwitchCase="'Rich text'">
                          <div
                            class="line-space mb-0 datacontent"
                            *ngIf="field.data"
                            [innerHTML]="field.data | highlight : searchQuery | safeHTML:'html'"
                          ></div>
                        </div>
                        <div *ngSwitchCase="'Upload Image'">
                          <img
                            [hidden]="field.data == ''"
                            class="img-fluid upload-img"
                            [src]="GlobalConstants.staticFilesURL + field.data"
                          />
                        </div>
                        <div *ngSwitchCase="'Upload Document'">
                          <a
                            class="doc-view"
                            [hidden]="field.data == ''"
                            target="_blank"
                            [href]="GlobalConstants.staticFilesURL + field.data"
                          >
                            <i
                              [hidden]="field.data == ''"
                              class="pi pi-file mx-2"
                            ></i
                            >{{ "Add file" | translator }}
                          </a>
                        </div>
                        <div *ngSwitchCase="'Data Item'">
                          <p class="color-bold">{{ field?.data?.name }}</p>
                          <p-accordion class="w-full" [multiple]="true">
                            <p-accordionTab
                              class="my-3"
                              *ngFor="
                                let field of field.data.fields;
                                let i = index
                              "
                              iconPos="end"
                            >
                              <ng-template pTemplate="header">
                                <div class="d-flex align-items-center">
                                  <i
                                    [ngClass]="
                                      field.label?.icon + ' font-1_2rem'
                                    "
                                    class="m-2"
                                  ></i>
                                  <span
                                    class="vertical-align-middle font-1_1rem"
                                    >{{ field.label?.name }}</span
                                  >
                                </div>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <div class="row">
                                  <div class="col-10">
                                    <div
                                      [ngSwitch]="
                                        getFieldType(field.label?.type)
                                      "
                                    >
                                      <!-- For text -->
                                      <div *ngSwitchCase="'text'">
                                        <div
                                          class="line-space mb-0 datacontent flex-column"
                                          *ngIf="field.data"
                                          [innerHTML]="
                                            field.data
                                              | highlight : searchQuery
                                              | safeHTML
                                          "
                                        ></div>
                                      </div>
                                      <!-- Rich text -->
                                      <div *ngSwitchCase="'Rich text'">
                                        <div
                                          class="line-space mb-0 datacontent flex-column"
                                          *ngIf="field.data"
                                          [innerHTML]="
                                            field.data
                                              | highlight : searchQuery
                                              | safeHTML
                                          "
                                        ></div>
                                      </div>
                                      <div *ngSwitchCase="'Upload Image'">
                                        <img
                                          [hidden]="field.data == ''"
                                          class="img-fluid upload-img"
                                          [src]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          "
                                        />
                                      </div>
                                      <div *ngSwitchCase="'Upload Document'">
                                        <a
                                          class="doc-view"
                                          [hidden]="field.data == ''"
                                          target="_blank"
                                          [href]="
                                            GlobalConstants.staticFilesURL +
                                            field.data
                                          "
                                        >
                                          <i
                                            [hidden]="field.data == ''"
                                            class="pi pi-file mx-2"
                                          ></i
                                          >{{ "Add file" | translator }}
                                        </a>
                                      </div>
                                      <div *ngSwitchCase="'Data Item'"></div>
                                      <div *ngSwitchDefault></div>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                          </p-accordion>
                        </div>
                        <div *ngSwitchDefault></div>
                      </div>
                    </div>
                    <!-- <div class="col-2 d-flex justify-content-end">
                                      <div *ngIf="hasPermission('u') && editPermission" class="editbutton"
                                          (click)="editFlag = i; editDataSave(field.data)">
                                          <p-button icon="pi pi-fw pi-pencil"></p-button>
                                      </div>
                                  </div> -->
                  </div>

                  <div *ngIf="editFlag" class="d-flex justify-content-between">
                    <div
                      class="w-100"
                      [ngSwitch]="getFieldType(field.label?.type)"
                    >
                      <!-- For text -->
                      <div *ngSwitchCase="'text'">
                        <i class="pi pi-clone"></i>
                        <input
                          pInputText
                          [(ngModel)]="field.data"
                          class="w-100"
                          [id]="field.label"
                          type="text"
                        />
                      </div>
                      <!-- Rich text -->
                      <div *ngSwitchCase="'Rich text'">
                        <p-editor plainTextPaste class="question-p-editor-grey"
                          [(ngModel)]="field.data"
                          (ngModelChange)="field.isChecked = true"
                          (onTextChange)="field.isChecked = true"
                          [style]="{ height: '320px' }"
                        ></p-editor>
                      </div>
                      <div *ngSwitchCase="'Upload Image'">
                        <img
                          [hidden]="field.data == ''"
                          class="img-fluid upload-img-dActive"
                          [src]="GlobalConstants.staticFilesURL + field.data"
                        />
                        <p-fileUpload
                          mode="basic"
                          chooseLabel="Choose"
                          name="file"
                          [url]="apilink + 'file/data'"
                          [auto]="true"
                          chooseLabel="Browse"
                          accept="image/*"
                          [maxFileSize]="1000000"
                          (onUpload)="
                            field.data = $event.originalEvent.body.data
                          "
                        ></p-fileUpload>
                      </div>
                      <div *ngSwitchCase="'Upload Document'">
                        <a
                          class="doc-view-dActive"
                          [hidden]="field.data == ''"
                          target="_blank"
                          [href]="GlobalConstants.staticFilesURL + field.data"
                        >
                          <i
                            [hidden]="field.data == ''"
                            class="pi pi-file mx-2"
                          ></i
                          >{{ "Add file" | translator }}
                        </a>
                        <p-fileUpload
                          mode="basic"
                          chooseLabel="Choose"
                          name="file"
                          [url]="apilink + 'file/data'"
                          [auto]="true"
                          chooseLabel="Add File"
                          [maxFileSize]="100000000"
                          (onUpload)="
                            field.data = $event.originalEvent.body.data
                          "
                        ></p-fileUpload>
                      </div>
                      <div *ngSwitchCase="'Data Item'">
                        <button
                          type="submit"
                          (click)="toggleModal(i)"
                          pButton
                          pRipple
                          label="{{ 'to update' | translator }}"
                          icon="pi pi-fw pi-plus-circle"
                          class="w-full my-3"
                        ></button>
                        <p-dialog
                          [blockScroll]="true"
                          [draggable]="false"
                          header="{{ 'Select a service' | translator }}"
                          [(visible)]="modalVisibilities[i]"
                          [style]="{ width: '70vw' }"
                        >
                          <app-select-service
                            (currentDataItem)="
                              changeCurrentDataItem($event, field, i)
                            "
                          >
                          </app-select-service>
                        </p-dialog>
                        <p class="font-bold" *ngIf="field.data">
                          {{ field.data.name }}
                        </p>
                      </div>
                      <div *ngSwitchDefault></div>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </span>
          </p-accordion>

          <!-- create comment -->
          <div
            [hidden]="!isLoggedIn"
            class="card rating-card border-none"
            id="comment-section"
            *ngIf="data.length > 0 && !editFlag"
          >
            <div>
              <span class="font-500"
                ><i class="pi pi-comments mx-2"></i
                >{{
                  "If there are any comments, write your comment" | translator
                }}
              </span>
              <div class="d-flex align-items-center flex-column mt-3">
                <span class="p-float-label m-2 w-100 222">
                  <textarea
                    class="comment-box w-100"
                    id="float-input"
                    rows="5"
                    pInputTextarea
                    [(ngModel)]="commentText"
                  ></textarea>
                  <label class="v4-label mx-2" for="float-input">{{
                    "comment" | translator
                  }}</label>
                </span>
                <div class="d-flex justify-content-end w-100">
                <button class="comment-btn" (click)="makeComment()">
                  <i class="pi pi-check mx-2"></i>{{ "send" | translator }}
                </button>
              </div>
                <p-messages
                  [(value)]="messages"
                  [enableService]="true"
                ></p-messages>
              </div>
            </div>
          </div>
          <!-- end create comment -->

          <div class="flex-mob-web mt-3">
            <ng-container   *ngIf="hasUnitPermission('VIEW_SIGN', 'r')">
              <div
              (click)="changeModal(true)"
                *ngIf="
                  !currentItem.signed || currentItem.signed.status == false;
                  else signedTemplate
                "
                class="d-flex justify-content-start flex-start mob-flex-column"
              >
                <div class="d-flex my-1">
                  <span class="btn-flex mx-1">
                    <span class="d-flex flex-column">
                      <span *ngIf="!currentItem.signed.user_name" class="btn-css mx-2">{{
                        "Not approved by the expert" | translator
                      }}</span>
                    <ng-container *ngIf="currentItem.signed.user_name">
                      <span class="mx-2"
                      >{{ "not available for ministry page" | translator }}   {{ currentItem.signed.user_name }}  
                    </span>
                    </ng-container>


                      <!-- <span class="btn-css mx-2 font-0_8rem font-weight-200">
                                      {{currentItem.updatedAt | date:'MMMM,d, y'}}
                                  </span> -->
                    </span>
                      <i class="pi pi-exclamation-circle font-500 mx-2"></i>
                  </span>
                </div>
              </div>
              <ng-template #signedTemplate>
                <div
                (click)="changeModal(true)"
                  class="d-flex justify-content-start flex-start mob-flex-column"
                >
                  <div class="d-flex my-1">
                    <span class="btn-flex mx-1">
                      <span class="d-flex flex-column">
                        <!-- <span class="btn-css mx-2">{{"Approved by the expert" | translator}}</span> -->
                        <span class="btn-css mx-2"
                          >{{ "Approved by the expert" | translator }} :
                          {{ currentItem.signed.user_name }}</span
                        >
                        <span class="btn-css mx-2 font-0_8rem font-weight-200">
                          {{ currentItem.signed.date | date : "MMMM,d, y" }}
                        </span>
                      </span>
                      <span class="icon-box">
                        <i class="pi pi-check-circle font-500"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </ng-template>
            </ng-container>
            <app-sign-history [dataId]="currentItem._id" [visible]="openSignModal" (close)="changeModal(false)" ></app-sign-history>
            <div class="flex-end-mob-web my-1">
              <span
                pTooltip="{{ 'Delete' | translator }}"
                tooltipPosition="top"
                *ngIf="hasUnitPermission('CONTENT', 'd') && deletePermission && hasEditPermissionWithType()"
                class="Ersaal-btn-delete mx-1 p-3"
                (click)="updateReasonModal(true)"
              >
                <i class="pi pi-trash font-500 font-1_2rem"></i>
              </span>
              <button
                pTooltip="{{ 'Print' | translator }}"
                tooltipPosition="top"
                class="btn-flex-2 mx-1 p-3"
                [useExistingCss]="true"
                styleSheetFile="search-result.component.scss"
                [printStyle]="{
                  '#print-data': { display: 'block' },
                  '*': { direction: 'rtl' },
                  html: { direction: 'rtl' },
                  body: { direction: 'rtl' }
                }"
                printSectionId="print-data"
                ngxPrint
              >
                <i class="pi pi-print font-500 font-1_2rem"></i>
              </button>
              <button
                pTooltip="{{ 'Copy Link' | translator }}"
                tooltipPosition="top"
                class="btn-flex-2 mx-1 p-3"
                (click)="copyLinkToClipboard()"
              >
                <i class="pi pi-link font-500 font-1_2rem"></i>
            </button>
              <span
                pTooltip="{{ 'EDIT' | translator }}"
                tooltipPosition="top"
                [hidden]="editFlag == false"
                class="mx-1"
              >
                <button
                  *ngIf="hasPermission('u') && editPermission"
                  class="btn-flex-3"
                  [disabled]="!hasAnyFieldChecked"
                  (click)="updateReasonModal()"
                >
                  <i class="pi pi-check m-l-2"></i>{{ "OK" | translator }}
                </button>
              </span>
              <span *ngIf="isLogin"
                pTooltip="{{ 'Favorite' | translator }}"
                tooltipPosition="top"
                class="mx-1"
              >
                <button
                  class="Ersaal-btn"
                  (click)="updateFavourite()"
                >
                  <i class="{{isFavorite() ? 'fa-solid fa-star':'fa-regular fa-star'}}"></i>
                </button>
              </span>
              <!-- <span *ngIf="hasPermission('u') && editPermission" class="btn-flex mx-1 p-3" (click)="updateData()">
                          <i class="pi pi-file-edit font-500 font-1_2rem"></i>
                      </span> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-md-8 col-12 my-2 d-flex align-items-center justify-content-center"
        style="height: 30rem"
        *ngIf="fetchingCurrent"
      >
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div
        class="col-md-8 col-12 my-2"
        *ngIf="
          !fetchingCurrent &&
          (currentItem == undefined ||
            currentItem == null ||
            currentItem?.fields?.length == 0)
        "
      >
        <!-- <app-no-data></app-no-data> -->
        <div class="container p-0">
          <div class="custom-my-10 bg-ui">
            <div class="row">
              <div class="col-md-1 col-2 d-flex align-items-center">
                <span class="pointer"
                  ><i class="fa-regular fa-hand-point-right"></i
                ></span>
              </div>
              <div class="col-md-11 col-10 d-flex justify-content-center">
                <h5 class="d-flex align-items-center flex-wrap text-lg-center m-0">
                  <i
                    class="pi pi-fw pi-exclamation-triangle font-2rem v4-ml-2"
                  ></i
                  >{{ "click on item to view details" | translator }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Printing Service Use Only -->

<div
  style="display: none; width: 100%"
  id="print-data"
  *ngIf="currentItem && currentItem?.fields.length > 0"
>
  <h2
    [hidden]="editFlag"
    class="card-title"
    style="font-weight: 600; color: var(--color-1); margin-bottom: 2rem"
  >
    {{ currentItem.name }}
  </h2>

  <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
    <ng-container
      *ngIf="
        currentItem &&
        currentItem.breadcrumbs &&
        currentItem.breadcrumbs.length > 0
      "
    >
      <span
        class="d-flex flex-row align-items-center"
        *ngFor="let parent of sortByDepth(currentItem?.breadcrumbs)"
      >
        <span
          class="btn-flex custom-bredcrum-btn ou-item align-items-center"
          style="background-color: grey"
        >
          <span
            class="btn-css mx-2 font-0_5rem"
            role="button"
            [routerLink]="'/category/' + parent.id"
            >{{ parent.label }}</span
          >
          <span class="icon-box" style="background-color: grey">
            <img
              src="{{ staticURL + parent?.icon }}"
              *ngIf="checkisImg(parent?.icon); else elseBlock"
              class="img-fluid"
              alt=""
            />
            <ng-template #elseBlock>
              <i class="pi pi-{{ parent.icon }} img-fluid"></i>
            </ng-template>
          </span>
        </span>
        <span>
          <i class="pi pi-fw pi-angle-left"></i>
        </span>
      </span>
    </ng-container>
    <span
      style="background-color: grey"
      class="my-1 btn-flex mx-1 ou-item active custom-bredcrum-btn align-items-center"
    >
      <span
        role="button"
        class="btn-css mx-2 font-0_5rem"
        [routerLink]="'/category/' + currentItem?.id"
        >{{ currentItem?.name }}</span
      >
      <span class="icon-box" style="background-color: grey">
        <img
          src="{{ staticURL + currentItem?.image_sq }}"
          *ngIf="checkisImg(currentItem?.image_sq); else elseBlock"
          class="img-fluid"
          alt=""
        />
        <ng-template #elseBlock>
          <i class="pi pi-{{ currentItem?.image }} align-self-center"></i>
        </ng-template>
      </span>
    </span>
  </div>

  <div style="margin: 1rem 0"></div>
  <span class="hr"></span>
  <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
    <span *ngFor="let field of currentItem?.fields; let i = index">
      <p-accordionTab
        *ngIf="field.data && field.data != '' && field.data != null"
        class="my-3"
        iconPos="end"
        [selected]="true"
      >
        <ng-template pTemplate="header">
          <div class="d-flex align-items-center">
            <p-checkbox
              (click)="$event.stopPropagation()"
              [hidden]="!editFlag"
              [(ngModel)]="field.isChecked"
              class="shadow"
              [binary]="true"
              inputId="binary"
            ></p-checkbox>
            <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
            <span class="vertical-align-middle font-1_1rem">{{
              field.label?.name
            }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div *ngIf="!editFlag" class="row">
            <!-- For View -->
            <div class="col-12">
              <div [ngSwitch]="getFieldType(field.label?.type)">
                <!-- For text -->
                <div *ngSwitchCase="'text'">
                  <div
                    class="line-space mb-0 datacontent"
                    *ngIf="field.data"
                    [innerHTML]="
                      field.data | highlight : searchQuery | safeHTML
                    "
                  ></div>
                </div>
                <!-- Rich text -->
                <div *ngSwitchCase="'Rich text'">
                  <div
                    class="line-space mb-0 datacontent"
                    *ngIf="field.data"
                    [innerHTML]="
                      field.data | highlight : searchQuery | safeHTML
                    "
                  ></div>
                </div>
                <div *ngSwitchCase="'Upload Image'">
                  <img
                    [hidden]="field.data == ''"
                    class="img-fluid upload-img"
                    [src]="GlobalConstants.staticFilesURL + field.data"
                  />
                </div>
                <div *ngSwitchCase="'Upload Document'">
                  <a
                    class="doc-view"
                    [hidden]="field.data == ''"
                    target="_blank"
                    [href]="GlobalConstants.staticFilesURL + field.data"
                  >
                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i
                    >{{ "Add file" | translator }}
                  </a>
                </div>
                <div *ngSwitchCase="'Data Item'">
                  <p class="color-bold">{{ field?.data?.name }}</p>
                  <p-accordion class="w-full" [multiple]="true">
                    <p-accordionTab
                      class="my-3"
                      [selected]="true"
                      *ngFor="let field of field.data.fields; let i = index"
                      iconPos="end"
                    >
                      <ng-template pTemplate="header">
                        <div class="d-flex align-items-center">
                          <i
                            [ngClass]="field.label?.icon + ' font-1_2rem'"
                            class="m-2"
                          ></i>
                          <span class="vertical-align-middle font-1_1rem">{{
                            field.label?.name
                          }}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="content">
                        <div class="row">
                          <div class="col-10">
                            <div [ngSwitch]="getFieldType(field.label?.type)">
                              <!-- For text -->
                              <div *ngSwitchCase="'text'">
                                <div
                                  class="line-space mb-0 datacontent flex-column"
                                  *ngIf="field.data"
                                  [innerHTML]="
                                    field.data
                                      | highlight : searchQuery
                                      | safeHTML
                                  "
                                ></div>
                              </div>
                              <!-- Rich text -->
                              <div *ngSwitchCase="'Rich text'">
                                <div
                                  class="line-space mb-0 datacontent flex-column"
                                  *ngIf="field.data"
                                  [innerHTML]="
                                    field.data
                                      | highlight : searchQuery
                                      | safeHTML
                                  "
                                ></div>
                              </div>
                              <div *ngSwitchCase="'Upload Image'">
                                <img
                                  [hidden]="field.data == ''"
                                  class="img-fluid upload-img"
                                  [src]="
                                    GlobalConstants.staticFilesURL + field.data
                                  "
                                />
                              </div>
                              <div *ngSwitchCase="'Upload Document'">
                                <a
                                  class="doc-view"
                                  [hidden]="field.data == ''"
                                  target="_blank"
                                  [href]="
                                    GlobalConstants.staticFilesURL + field.data
                                  "
                                >
                                  <i
                                    [hidden]="field.data == ''"
                                    class="pi pi-file mx-2"
                                  ></i
                                  >{{ "Add file" | translator }}
                                </a>
                              </div>
                              <div *ngSwitchCase="'Data Item'"></div>
                              <div *ngSwitchDefault></div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-accordionTab>
                  </p-accordion>
                </div>
                <div *ngSwitchDefault></div>
              </div>
            </div>
            <!-- <div class="col-2 d-flex justify-content-end">
                          <div *ngIf="hasPermission('u') && editPermission" class="editbutton"
                              (click)="editFlag = i; editDataSave(field.data)">
                              <p-button icon="pi pi-fw pi-pencil"></p-button>
                          </div>
                      </div> -->
          </div>

          <div *ngIf="editFlag" class="d-flex justify-content-between">
            <div class="w-100" [ngSwitch]="getFieldType(field.label?.type)">
              <!-- For text -->
              <div *ngSwitchCase="'text'">
                <i class="pi pi-clone"></i>
                <input
                  pInputText
                  [(ngModel)]="field.data"
                  class="w-100"
                  [id]="field.label"
                  type="text"
                />
              </div>
              <!-- Rich text -->
              <div *ngSwitchCase="'Rich text'">
                <p-editor
                  plainTextPaste
                  [(ngModel)]="field.data"
                  [style]="{ height: '320px' }"
                ></p-editor>
              </div>
              <div *ngSwitchCase="'Upload Image'">
                <img
                  [hidden]="field.data == ''"
                  class="img-fluid upload-img-dActive"
                  [src]="GlobalConstants.staticFilesURL + field.data"
                />
                <p-fileUpload
                  mode="basic"
                  chooseLabel="Choose"
                  name="file"
                  [url]="apilink + 'file/data'"
                  [auto]="true"
                  chooseLabel="Browse"
                  accept="image/*"
                  [maxFileSize]="1000000"
                  (onUpload)="field.data = $event.originalEvent.body.data"
                ></p-fileUpload>
              </div>
              <div *ngSwitchCase="'Upload Document'">
                <a
                  class="doc-view-dActive"
                  [hidden]="field.data == ''"
                  target="_blank"
                  [href]="GlobalConstants.staticFilesURL + field.data"
                >
                  <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i
                  >{{ "Add file" | translator }}
                </a>
                <p-fileUpload
                  mode="basic"
                  chooseLabel="Choose"
                  name="file"
                  [url]="apilink + 'file/data'"
                  [auto]="true"
                  chooseLabel="Add File"
                  [maxFileSize]="100000000"
                  (onUpload)="field.data = $event.originalEvent.body.data"
                ></p-fileUpload>
              </div>
              <div *ngSwitchCase="'Data Item'">
                <p>{{ field?.data?.name }}</p>
                <p-accordion class="w-full" [multiple]="true">
                  <p-accordionTab
                    class="my-3"
                    *ngFor="let field of field.data.fields; let i = index"
                    iconPos="end"
                    [selected]="true"
                  >
                    <ng-template pTemplate="header">
                      <div class="d-flex align-items-center">
                        <i
                          [ngClass]="field.label?.icon + ' font-1_2rem'"
                          class="m-2"
                        ></i>
                        <span class="vertical-align-middle font-1_1rem">{{
                          field.label?.name
                        }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <div class="row">
                        <div class="col-10">
                          <div [ngSwitch]="getFieldType(field.label?.type)">
                            <!-- For text -->
                            <!-- For text -->
                            <div *ngSwitchCase="'text'">
                              <i class="pi pi-clone"></i>
                              <input
                                pInputText
                                [(ngModel)]="field.data"
                                class="w-100"
                                [id]="field.label"
                                type="text"
                              />
                            </div>
                            <!-- Rich text -->
                            <div *ngSwitchCase="'Rich text'">
                              <p-editor
                                plainTextPaste
                                [(ngModel)]="field.data"
                                [style]="{ height: '320px' }"
                              ></p-editor>
                            </div>
                            <div *ngSwitchCase="'Upload Image'">
                              <img
                                [hidden]="field.data == ''"
                                class="img-fluid upload-img-dActive"
                                [src]="
                                  GlobalConstants.staticFilesURL + field.data
                                "
                              />
                              <p-fileUpload
                                mode="basic"
                                chooseLabel="Choose"
                                name="file"
                                [url]="apilink + 'file/data'"
                                [auto]="true"
                                chooseLabel="Browse"
                                accept="image/*"
                                [maxFileSize]="1000000"
                                (onUpload)="
                                  field.data = $event.originalEvent.body.data
                                "
                              ></p-fileUpload>
                            </div>
                            <div *ngSwitchCase="'Upload Document'">
                              <a
                                class="doc-view-dActive"
                                [hidden]="field.data == ''"
                                target="_blank"
                                [href]="
                                  GlobalConstants.staticFilesURL + field.data
                                "
                              >
                                <i
                                  [hidden]="field.data == ''"
                                  class="pi pi-file mx-2"
                                ></i
                                >{{ "Add file" | translator }}</a
                              >
                              <p-fileUpload
                                mode="basic"
                                chooseLabel="Choose"
                                name="file"
                                [url]="apilink + 'file/data'"
                                [auto]="true"
                                chooseLabel="Add File"
                                [maxFileSize]="100000000"
                                (onUpload)="
                                  field.data = $event.originalEvent.body.data
                                "
                              ></p-fileUpload>
                            </div>
                            <div *ngSwitchDefault></div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </p-accordion>
              </div>
              <div *ngSwitchDefault></div>
            </div>
          </div>
        </ng-template>
      </p-accordionTab>
    </span>
  </p-accordion>
</div>

<p-toast></p-toast>

<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="{{ 'OK' | translator }}"
      (click)="cd.accept()"
    ></button>
      
  </ng-template>
</p-confirmDialog>

<!-- Update Reason modal -->
<div class="card flex justify-content-center">
  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    header="{{ 'the reason' | translator }}"
    [(visible)]="reasonModal"
    [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }"
    [maximizable]="true"
  >
    <div class="w-100">
      <p>{{ "the reason" | translator }}</p>
      <p-editor plainTextPaste class="question-p-editor" [(ngModel)]="reasonHolder" [style]="{ height: '320px' }">
      </p-editor>
      <p *ngIf="reasonError" style="color: red">
        {{ "Please Write a reason for update" | translator}}
      </p>
    </div>
    <ng-template pTemplate="footer">
      <button class="v4-btn-every py-2" (click)="updateData()">
        <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
      </button>
    </ng-template>
  </p-dialog>
</div>

<app-footer></app-footer>
